import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e3240ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "list-grid" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "product-img" }
const _hoisted_4 = { class: "product-name" }
const _hoisted_5 = {
  key: 0,
  class: "activity-empty"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/activity/christmas/empty.png",
  alt: ""
}, null, -1))
const _hoisted_7 = {
  key: 0,
  class: "list-page flex-end"
}

import { Ref, ref, toRef, watch } from 'vue'
import { goodsShopAdd, goodsShopSetting } from '@/apis/usercenter'
import PopBtn from '@/components/common/PopBtn.vue'
import { t } from '@/plugins/i18n'
import { isJA, useRtfix } from '@/store'
import { confirmUnlike } from '@/util/useConfirm'
import { ElMessage } from 'element-plus'
import ShopItem from '@/components/common/ShopItem.vue'
import Image from '@/components/common/Image.vue'
import { useRouter } from 'vue-router'
import { setValue } from '@/views/brand/components/suffix'

interface Item {
  [key: string]: any
}

export default /*#__PURE__*/_defineComponent({
  props: ['pageNum', 'pageSize', 'data', 'loading', 'behaviorChannel', 'type'],
  emits: ['update:pageNum', 'update:pageSize', 'success'],
  setup(__props, { emit }) {

const props = __props


const data = toRef(props, 'data')

const router = useRouter()
// const texts = ['找相似', '円', '销量', '件'].map(t)

const list: Ref<Item[]> = ref([])
const total: Ref<number> = ref(0)

watch(data, (v) => {
  setValue(v.records)
  list.value = v.records.map((v:any) => ({
    ...v,
    imgs: JSON.parse(v.productImgs ?? '[]')
  }))
  v.total && (total.value = v.total)
})
const jump = (v) => {
  router.push(useRtfix('ckbDetail', { params: { code: v.atlasCode } }))
}

return (_ctx: any,_cache: any) => {
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (v) => {
        return (_openBlock(), _createElementBlock("div", {
          key: v.shopCode,
          class: "list-item rel cursor-pt",
          onClick: ($event: any) => (jump(v))
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(Image, {
              src: v.headerImage,
              alt: "",
              fit: "cover",
              class: "img"
            }, null, 8, ["src"])
          ]),
          _createElementVNode("div", _hoisted_4, "PRODUCT# " + _toDisplayString(v.atlasCode), 1)
        ], 8, _hoisted_2))
      }), 128)),
      (list.value.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", null, _toDisplayString(_unref(t)('暂无数据')), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    (total.value > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(_component_el_pagination, {
            background: "",
            layout: "prev,pager,next,sizes,jumper",
            currentPage: __props.pageNum,
            "page-size": __props.pageSize,
            total: total.value,
            onCurrentChange: _cache[0] || (_cache[0] = ($event: any) => (emit('update:pageNum', $event))),
            onSizeChange: _cache[1] || (_cache[1] = ($event: any) => (emit('update:pageSize', $event)))
          }, null, 8, ["currentPage", "page-size", "total"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})